/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationsControllerFindAllQueryResponse, WorkflowApplicationsControllerFindAllQueryParams, WorkflowApplicationsControllerFindAll401, WorkflowApplicationsControllerFindAll403 } from "../../models/workflowsController/WorkflowApplicationsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { workflowApplicationsControllerFindAll } from "../../clients/workflowsService/workflowApplicationsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const workflowApplicationsControllerFindAllQueryKey = (params: WorkflowApplicationsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/workflow-applications'
}, ...(params ? [params] : [])] as const;
export type WorkflowApplicationsControllerFindAllQueryKey = ReturnType<typeof workflowApplicationsControllerFindAllQueryKey>;
export function workflowApplicationsControllerFindAllQueryOptions(params?: WorkflowApplicationsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = workflowApplicationsControllerFindAllQueryKey(params);
  return queryOptions<WorkflowApplicationsControllerFindAllQueryResponse, ResponseErrorConfig<WorkflowApplicationsControllerFindAll401 | WorkflowApplicationsControllerFindAll403>, WorkflowApplicationsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return workflowApplicationsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List workflow applications (scope-filtered)
 * {@link /api/v1/workflow-applications}
 */
export function useWorkflowApplicationsControllerFindAll<TData = WorkflowApplicationsControllerFindAllQueryResponse, TQueryData = WorkflowApplicationsControllerFindAllQueryResponse, TQueryKey extends QueryKey = WorkflowApplicationsControllerFindAllQueryKey>(params?: WorkflowApplicationsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<WorkflowApplicationsControllerFindAllQueryResponse, ResponseErrorConfig<WorkflowApplicationsControllerFindAll401 | WorkflowApplicationsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? workflowApplicationsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...workflowApplicationsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WorkflowApplicationsControllerFindAll401 | WorkflowApplicationsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}